import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import classNames from 'classnames'
import PropTypes from 'prop-types'

// const css = typeof window === 'undefined' ? {} : require('./styles.scss')
import { BUTTON_ATTRS, filterElemAttrs } from '../react-helpers'

const GENEVA_BUTTON_CSS_CLASS = 'geneva-button'

export default class GenevaButton extends Component {

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.object, PropTypes.array, PropTypes.string
    ]),
    className: PropTypes.string,
    onClick: PropTypes.func,
  }


  constructor(props) {
    super(props)
    this.focus = this.focus.bind(this)
    this.handleClick = this.handleClick.bind(this)
    
  }
  // Overwritting contains function for:
  // DropdownOpener component checks for contains on ref
  contains(event) {
    return this.openerRef.contains(event)
  }

  @autobind
  focus() {
    this.openerRef.focus()
  }

  @autobind
  handleClick(event) {
    if (this.props.onClick) {
      this.props.onClick(event)
    }
  }

  render() {
    const { className, children } = this.props
    return (
      <button
        // eslint-disable-next-line no-return-assign
        ref={ref => (this.openerRef = ref)}
        {...filterElemAttrs(this.props, BUTTON_ATTRS)}
        className={classNames(GENEVA_BUTTON_CSS_CLASS, className)}
        onClick={this.handleClick}
      >
        {children}
      </button>
    )
  }
}
